import { Text, VStack } from "@chakra-ui/react";
import { SettingToggle } from "../SettingToggle/SettingToggle";

interface ChannelSwitchProps {
  // Channel name shown above the control ("Email", "Text").
  label: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  ariaLabel: string;
  // When set, the channel isn't offered for this row: the text is shown in
  // place of the toggle (e.g. "Email only" for a category that can't be texted).
  unavailableText?: string;
}

// A labeled notification-channel toggle, stacked vertically so several
// channels line up as columns in a settings row.
export const ChannelSwitch = ({
  label,
  checked,
  onChange,
  disabled,
  ariaLabel,
  unavailableText,
}: ChannelSwitchProps) => (
  <VStack gap="5px" align="center" w="48px">
    <Text
      textStyle="switchLabel"
      color={checked && !unavailableText ? "fg.brand" : "fg.muted"}
    >
      {label}
    </Text>
    {unavailableText ? (
      <Text textStyle="inputLabel" color="fg.subtle">
        {unavailableText}
      </Text>
    ) : (
      <SettingToggle
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        ariaLabel={ariaLabel}
      />
    )}
  </VStack>
);
